import { Tag, TagCloseButton, TagLabel, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { CpvCodeDto } from "../../autogen/bff-api";

type Props = {
  selected: string[];
  codeIndex: Record<string, CpvCodeDto>;
  onRemove: (code: string) => void;
};

export const CpvSelectedChips = ({ selected, codeIndex, onRemove }: Props) => {
  const { i18n } = useTranslation();
  if (selected.length === 0) return null;
  const isNorwegian = i18n.language.startsWith("no");
  return (
    <VStack align="stretch" spacing="1" mb="2">
      {selected.map((code) => {
        const dto = codeIndex[code];
        const label = dto ? (isNorwegian ? dto.nameNb : dto.nameEn) : "";
        return (
          <Tag key={code} colorScheme="teal" variant="subtle" size="md" alignSelf="flex-start" maxW="100%">
            <TagLabel whiteSpace="normal">
              {code}
              {label ? ` — ${label}` : ""}
            </TagLabel>
            <TagCloseButton onClick={() => onRemove(code)} />
          </Tag>
        );
      })}
    </VStack>
  );
};
